import { createApi } from '@reduxjs/toolkit/query/react'
import { IChatboxResponse, ITopics } from '../../interfaces/chats/IChatResponse'
import { deviceInfoAxiosQuery } from '../../utils/axios/deviceInfo.axios'
import { ICards } from '../../interfaces/cards/ICards'
import { IPage } from '../../interfaces/models/models/paginated-response.model'

export const chatboxApi = createApi({
    reducerPath: 'chatbox',
    baseQuery: deviceInfoAxiosQuery(),
	tagTypes: ['trips','brand', 'topics', 'chats', 'updated-news'],
    endpoints: (builder) => ({
		getBrandingConfig: builder.query<ICards[], string>({
			query: (hotel) => ({
				url: `/branding-configs/${hotel}/SOFIA`,
				method: 'GET',
			}),
			providesTags: ['brand']
		}),
		uploadChatFile: builder.mutation<{name: string, url: string}[], FormData>({
			query: (data) => ({
				url: `/rebecca-ai-agent/upload-files`,
				method: 'POST',
				data
			}),
		}),
		getCards: builder.query<ICards[], void>({
			query: () => ({
				url: `/cards`,
				method: 'GET',
			}),
			providesTags: ['updated-news']
		}),
		chatbox: builder.mutation<{data: IChatboxResponse}, {
			tripId:string,
			message: string, 
			action?: string,
			feedbackId?: string,
			cabinId?: string,
			files?: {name: string, url: string}[], 
			topic?: string, 
			// user: {name: string, email: string, id: string}
		}>({
			query: (payload) => ({
				url: `/rebecca-ai-agent/staff-feedback`,
				method: 'POST',
				data: payload,
			}),
		}),
		chatboxFile: builder.mutation<{data: IChatboxResponse}, FormData>({
			query: (payload) => ({
				url: `/chatbox/chat`,
				method: 'POST',
				data: payload,
				// headers: {
				// 'Access-Control-Allow-Origin': '*',
				// },
			}),
		}),
		topicsList: builder.query<{data: {elements: ITopics[], page: IPage}}, void>({
			query: () => ({
				url: '/rebecca-ai-agent/feedback-topics',
				method: 'GET'
			}),
			providesTags: ['topics']
		}),
		getTopicChats: builder.mutation<{data: {elements: IChatboxResponse[], page: IPage}}, string>({
			query: (topicId) => ({
				url: `/rebecca-ai-agent/feedback-chats/topic/${topicId}`,
				method: 'GET'
			})
		}),
		saveTopic: builder.mutation<{data: IChatboxResponse[]}, string>({
			query: (topic) => ({
				url: `/chatbox/chat/${topic}/topic`,
				method: 'PUT'
			}),
			invalidatesTags: ['topics']
		}),
		reactMessage: builder.mutation<{data: IChatboxResponse[]}, {action: 'like' | 'dislike' | 'favorite', messageId: string}>({
			query: ({action, messageId}) => ({
				url: `/chatbox/messages/${messageId}/reaction`,
				method: 'PUT',
				data: {action}
			}),
		}),
		reportIssue: builder.mutation<{data: IChatboxResponse[]}, { messageId: string,  userIssue: string,  topicId: string}>({
			query: ({ messageId, userIssue, topicId}) => ({
				url: `/chatbox/chats/issues/report`,
				method: 'PUT',
				data: {messageId, userIssue, topicId}
			}),
		}),
    }),
})

export const {
	useGetBrandingConfigQuery,
	useGetCardsQuery,
	useUploadChatFileMutation,
	useChatboxMutation,
	useChatboxFileMutation,
	useTopicsListQuery,
	useGetTopicChatsMutation,
	useSaveTopicMutation,
	useReactMessageMutation,
	useReportIssueMutation
} = chatboxApi